<div style="margin: 15px 0;">
<form [formGroup]="pairingForm">
   <select formControlName="ladderId">
      <option *ngFor="let l of ladders" [value]="l.ladderId">{{l.ladderId}} - {{l.name}}</option>
   </select>
   <br />
   <select formControlName="levelId">
      <option *ngFor="let l of levels" [ngValue]="l.id">{{l.id}} - {{l.nameLong}}</option>
   </select>
   <br />


   <br />

   <table class="table table-bordered table-striped">
    <thead class="thead-green">
      <tr>
        <th>Team</th>
        <th>Player</th>
        <th style="text-align:center;">Email</th>
        <th style="text-align:center;">Phone</th>
      </tr>
    </thead>


    <tbody class="table-striped">
      <ng-container *ngFor="let playerList of players">
        <tr>
         <td>
            {{playerList[0].doublesName}}
          </td>
          <td>
            <div *ngFor="let player of playerList">

              <span  *ngIf="playerList[0].doublesName == 'No Partner Yet'"><input id="{{player.id}}" type="checkbox" (change)="checkClicked($event)" /></span>

               <label for="{{player.id}}">
                           <span>&nbsp;{{player.getFullName()}}<sup>{{player.rank||'N/R'}}</sup></span>
               </label>

            </div>
          </td>
          <td class="hide-small">
            <div *ngFor="let player of playerList">
              <span>{{player.email}}</span>
            </div>
          </td>

          <td class="hide-small">
            <div *ngFor="let player of playerList">
              <span>{{player.phoneNumber}}</span>
            </div>
          </td>


        </tr>
      </ng-container>
    </tbody>
  </table>
<button (click)="submit($event)">Submit Pairing</button>
  
</form>
</div>